const TIME_ZONE = "Asia/Kolkata";

export function formatDuration(totalSeconds) {
  const seconds = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  if (hours === 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}m`;
}

export function formatHours(totalSeconds, digits = 1) {
  return (Math.max(0, Number(totalSeconds) || 0) / 3600).toFixed(digits);
}

export function formatDateLong(isoOrYmd) {
  if (!isoOrYmd) return "—";
  const date = isoOrYmd.length === 10
    ? new Date(`${isoOrYmd}T12:00:00+05:30`)
    : new Date(isoOrYmd);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: TIME_ZONE,
  });
}

export function formatTime(iso, { seconds = false } = {}) {
  if (!iso) return "—";
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    ...(seconds ? { second: "2-digit" } : {}),
    timeZone: TIME_ZONE,
  });
}

export function statusMeta(status) {
  if (status === "STOPPED") {
    return { label: "Completed", tone: "done" };
  }
  if (status === "RUNNING") {
    return { label: "Running", tone: "running" };
  }
  if (status === "PAUSED") {
    return { label: "Paused", tone: "paused" };
  }
  if (status === "AUTO_PAUSED") {
    return { label: "Inactive", tone: "auto" };
  }
  return { label: status || "Unknown", tone: "muted" };
}

export function eventCopy(eventType) {
  if (eventType === "START") return "Session started";
  if (eventType === "PAUSE") return "Paused";
  if (eventType === "AUTO_PAUSE") return "Auto-paused — inactivity detected";
  if (eventType === "RESUME") return "Resumed";
  if (eventType === "AUTO_RESUME") return "Auto-resumed";
  if (eventType === "STOP") return "Session stopped";
  if (eventType === "LOGOUT") return "Session stopped";
  return eventType || "Event";
}

export function eventTone(eventType) {
  if (eventType === "START" || eventType === "RESUME" || eventType === "AUTO_RESUME") return "start";
  if (eventType === "PAUSE") return "paused";
  if (eventType === "AUTO_PAUSE") return "auto";
  if (eventType === "STOP" || eventType === "LOGOUT") return "stop";
  return "muted";
}

export function collapseDuplicateEvents(events = []) {
  return events.filter((event, index) => {
    if (index === 0) return true;
    const prev = events[index - 1];
    if (event.eventType !== "AUTO_RESUME" || prev.eventType !== "AUTO_RESUME") return true;
    const gap = Math.abs(new Date(event.eventTime).getTime() - new Date(prev.eventTime).getTime());
    return gap > 2000;
  });
}
